import {
  SourceAttribute,
  SourceCondition,
  SourceConstant,
  SourceCustomExpression,
  SourceFunction,
} from '../../resource/detail/controls/synchronization/abstract-attribute-flow-control';
import {ParseTreeVisitor} from '../../utils/interop/antlr4';
// @ts-ignore - Generated ANTLR files don't have TypeScript definitions
import customExpressionParserModule from './customExpressionParser.js';

export class customExpressionVisitor extends ParseTreeVisitor<any> {
  private customExpressionParser = customExpressionParserModule.customExpressionParser;

  // Visit a parse tree produced by customExpressionParser#start.
  //start: (anyType | condition) EOF;
  visitStart(ctx: ParserRuleContext): SourceCustomExpression {
    if (ctx.children.length >= 1) {
      const res = this.visit(ctx.children[0]);
      if (res instanceof SourceFunction || res instanceof SourceCondition) {
        return new SourceCustomExpression(res);
      } else {
        throw 'Invalid expression. Only function or condition allowed.';
      }
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#anyType.
  //anyType: stringType | intType | byteArrayType | fnNull | fnIIF;
  visitAnyType(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#stringType.
  //stringType: stringTypeNoConcat | stringConcatenation;
  visitStringType(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#stringTypeNoConcat.
  //stringTypeNoConcat: string | stringFunction | attribute | fnIIF | fnNull;
  visitStringTypeNoConcat(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#stringFunction.
  //stringFunction: unaryStringFunction | fnPadString | fnDateTimeFormat | fnConvertSidToString | fnReplaceString | fnWord | fnLeftRight | fnMid | fnCRLF;
  visitStringFunction(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#stringConcatenation.
  //stringConcatenation: stringTypeNoConcat '+' stringType;
  visitStringConcatenation(ctx: ParserRuleContext): SourceFunction {
    let fn = null;
    try {
      fn = new SourceFunction();
      fn.functionName = '+';

      fn.arguments.push(this.visit(ctx.children[0]));
      const arg2 = this.visit(ctx.children[2]);

      if (arg2 instanceof SourceFunction && arg2.functionName === '+') {
        fn.arguments.push(...arg2.arguments);
      } else {
        fn.arguments.push(arg2);
      }
    } catch (e) {}

    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#intType.
  //intType: number | hex | intFunction | attribute | fnIIF | fnNull;
  visitIntType(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#intFunction.
  //intFunction: fnBitInt | fnRandomNum;
  visitIntFunction(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#byteArrayType.
  //byteArrayType: byteArrayFunction | attribute | fnIIF | fnNull;
  visitByteArrayType(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#byteArrayFunction.
  //byteArrayFunction: fnConvertStringToGuid;
  visitByteArrayFunction(ctx: ParserRuleContext) {
    if (ctx.children.length === 1) {
      return this.visit(ctx.children[0]);
    } else {
      return null;
    }
  }

  // Visit a parse tree produced by customExpressionParser#unaryStringFunction.
  //unaryStringFunction: UnaryStringFunctionName '(' stringType ')';
  visitUnaryStringFunction(ctx: ParserRuleContext): SourceFunction {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = ctx.children[0].symbol.text;
      fn.arguments.push(this.visitStringType(ctx.children[2]));
    } catch (e) {}

    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnPadString.
  //fnPadString: ('RightPad' | 'LeftPad') '(' stringType ',' intType ',' stringType ')';
  visitFnPadString(ctx: ParserRuleContext): SourceFunction {
    let fn = null;
    try {
      fn = new SourceFunction();
      fn.functionName = ctx.children[0].symbol.text;

      const string = this.visitStringType(ctx.children[2]);
      const length = this.visitIntType(ctx.children[4]);
      const padCharacter = this.visitStringType(ctx.children[6]);

      fn.arguments.push(string);
      fn.arguments.push(length);
      fn.arguments.push(padCharacter);
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnDateTimeFormat.
  //fnDateTimeFormat: 'DateTimeFormat' '(' stringType ',' stringType ')';
  visitFnDateTimeFormat(ctx: ParserRuleContext): SourceFunction {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'DateTimeFormat';
      fn.arguments.push(this.visitStringType(ctx.children[2]));
      fn.arguments.push(this.visitStringType(ctx.children[4]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnConvertSidToString.
  //fnConvertSidToString: 'ConvertSidToString' '(' byteArrayType ')';
  visitFnConvertSidToString(ctx: ParserRuleContext): SourceFunction {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'ConvertSidToString';
      fn.arguments.push(this.visitByteArrayType(ctx.children[2]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnReplaceString.
  //fnReplaceString: 'ReplaceString' '(' stringType ',' stringType ',' stringType ')';
  visitFnReplaceString(ctx: ParserRuleContext): SourceFunction {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'ReplaceString';
      fn.arguments.push(this.visitStringType(ctx.children[2]));
      fn.arguments.push(this.visitStringType(ctx.children[4]));
      fn.arguments.push(this.visitStringType(ctx.children[6]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnWord.
  //fnWord: 'Word' '(' stringType ',' intType ',' stringType ')';
  visitFnWord(ctx: ParserRuleContext) {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'Word';
      fn.arguments.push(this.visitStringType(ctx.children[2]));
      fn.arguments.push(this.visitIntType(ctx.children[4]));
      fn.arguments.push(this.visitStringType(ctx.children[6]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnLeftRight.
  //fnLeftRight: ('Left' | 'Right') '(' stringType ',' intType ')';
  visitFnLeftRight(ctx: ParserRuleContext) {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = ctx.children[0].symbol.text;
      fn.arguments.push(this.visitStringType(ctx.children[2]));
      fn.arguments.push(this.visitIntType(ctx.children[4]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnMid.
  //fnMid: 'Mid' '(' stringType ',' intType ',' intType ')';
  visitFnMid(ctx: ParserRuleContext) {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'Mid';
      fn.arguments.push(this.visitStringType(ctx.children[2]));
      fn.arguments.push(this.visitIntType(ctx.children[4]));
      fn.arguments.push(this.visitIntType(ctx.children[6]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnCRLF.
  //fnCRLF: 'CRLF' '(' ')';
  visitFnCRLF(ctx: ParserRuleContext): SourceFunction {
    const fn = new SourceFunction();
    fn.functionName = 'CRLF';
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnBitInt.
  //fnBitInt: ('BitAnd' | 'BitOr') '(' intType ',' intType ')';
  visitFnBitInt(ctx: ParserRuleContext) {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = ctx.children[0].symbol.text;
      fn.arguments.push(this.visitIntType(ctx.children[2]));
      fn.arguments.push(this.visitIntType(ctx.children[4]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnRandomNum.
  //fnRandomNum: 'RandomNum' '(' intType ',' intType ')';
  visitFnRandomNum(ctx: ParserRuleContext) {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'RandomNum';
      fn.arguments.push(this.visitIntType(ctx.children[2]));
      fn.arguments.push(this.visitIntType(ctx.children[4]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnConvertStringToGuid.
  //fnConvertStringToGuid: 'ConvertStringToGuid' '(' stringType ')';
  visitFnConvertStringToGuid(ctx: ParserRuleContext) {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'ConvertStringToGuid';
      fn.arguments.push(this.visitStringType(ctx.children[2]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnNull.
  //fnNull: 'Null' '(' ')';
  visitFnNull(ctx: ParserRuleContext): SourceFunction {
    const fn = new SourceFunction();
    fn.functionName = 'Null';
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#fnIIF.
  //fnIIF: 'IIF' '(' condition ',' anyType ',' anyType ')';
  visitFnIIF(ctx: ParserRuleContext): SourceFunction {
    let fn: SourceFunction = null;
    try {
      fn = new SourceFunction();
      fn.functionName = 'IIF';
      fn.arguments.push(this.visitCondition(ctx.children[2]));
      fn.arguments.push(this.visitAnyType(ctx.children[4]));
      fn.arguments.push(this.visitAnyType(ctx.children[6]));
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by customExpressionParser#condition.
  //condition: conditionAny | conditionNumeric | 'IsPresent' '(' attribute ')';
  visitCondition(ctx: ParserRuleContext): SourceCondition {
    if (ctx == null || !Array.isArray(ctx.children)) {
      return null;
    }

    if (ctx.children.length === 1) {
      //conditionAny and conditionNumeric
      return this.visit(ctx.children[0]);
    }

    if (ctx.children.length !== 4) {
      return null;
    }

    //IsPresent
    let cond: SourceCondition = null;
    try {
      cond = new SourceCondition();
      cond.functionName = 'IsPresent';
      cond.arguments.push(this.visitAttribute(ctx.children[2]));
    } catch (e) {}
    return cond;
  }

  // Visit a parse tree produced by customExpressionParser#conditionAny.
  //conditionAny: ('Eq' | 'NotEquals') '(' anyType ',' anyType ')';
  visitConditionAny(ctx: ParserRuleContext) {
    let cond: SourceCondition = null;
    try {
      cond = new SourceCondition();
      cond.functionName = ctx.children[0].symbol.text;
      cond.arguments.push(this.visitAnyType(ctx.children[2]));
      cond.arguments.push(this.visitAnyType(ctx.children[4]));
    } catch (e) {}
    return cond;
  }

  // Visit a parse tree produced by customExpressionParser#conditionNumeric.
  //conditionNumeric: ('LessThan' | 'LessThan' | 'LessThanOrEquals' | 'GreaterThanOrEquals') '(' intType ',' intType ')';
  visitConditionNumeric(ctx: ParserRuleContext): SourceCondition {
    let cond: SourceCondition = null;
    try {
      cond = new SourceCondition();
      cond.functionName = ctx.children[0].symbol.text;
      cond.arguments.push(this.visitIntType(ctx.children[2]));
      cond.arguments.push(this.visitIntType(ctx.children[4]));
    } catch (e) {}
    return cond;
  }

  // Visit a parse tree produced by customExpressionParser#attribute.
  //attribute: QNAME;
  visitAttribute(ctx: ParserRuleContext) {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      v = new SourceAttribute(v);
    } catch (e) {}

    return v;
  }

  // Visit a parse tree produced by customExpressionParser#number.
  //number: NUMBER;
  visitNumber(ctx: ParserRuleContext) {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      v = new SourceConstant('Number', v);
    } catch (e) {}

    return v;
  }

  // Visit a parse tree produced by customExpressionParser#hex.
  //hex: HEX;
  visitHex(ctx: ParserRuleContext) {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      v = new SourceConstant('Number', v);
    } catch (e) {}

    return v;
  }

  // Visit a parse tree produced by customExpressionParser#string.
  //string: STRING;
  visitString(ctx: ParserRuleContext): SourceConstant {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      const quotationMark = v[0];
      v = v.substr(1, v.length - 2);
      v = v.replace(new RegExp('\\\\' + quotationMark, 'g'), quotationMark);
      v = v.replace(/\\\\/g, '\\');
      v = new SourceConstant('String', v);
    } catch (e) {}

    return v;
  }
}

class ParserRuleContext {
  parentCtx: ParserRuleContext;
  invokingState: number;
  children: any[];
  start: any;
  stop: any;
  ruleIndex: number;
  exception: any;
  parser: any;
}
